<template>
  <div class="content-benefits-skeleton">
    <ul class="content-benefits-skeleton__grid">
      <li v-for="i in 4" :key="i" class="content-benefits-skeleton__item">
        <div class="content-benefits-skeleton__icon">
          <PSkeleton />
        </div>
        <div class="content-benefits-skeleton__item-content">
          <SHeadingSkeleton size="3" width="10rem" />
          <STextSkeleton :lines="3" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import {
  PSkeleton,
  SHeadingSkeleton,
  STextSkeleton,
} from "@solvari/components";
</script>

<style lang="postcss">
.content-benefits-skeleton {
  &__grid {
    @apply grid gap-4 grid-cols-auto-128 grid-cols-auto-grow;
  }

  &__item {
    @apply flex list-none flex-row items-start gap-4;
  }

  &__icon {
    @apply flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700;
    margin-top: 0.3125rem;
  }

  &__item-content {
    @apply flex w-full flex-col gap-1;
  }
}
</style>
